export const APPLICATION_STATUSES = [
  "Pending",
  "In Review",
  "Approved",
  "Funds Transferred",
  "Rejected",
];

export const STATUS_COLOR = {
  Pending: "text-amber-300 border-amber-300/40",
  "In Review": "text-blue-300 border-blue-300/40",
  Approved: "text-emerald-300 border-emerald-300/40",
  "Funds Transferred": "text-[#D4AF37] border-[#D4AF37]/60",
  Rejected: "text-red-400 border-red-400/40",
};
